/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo } from "react";
import { Button, Spin } from "antd";
import {
  SurveyLinkWrapper,
  ToolbarRow,
  ContentArea,
  LinkHeader,
  ChartContainer,
} from "./styled";

import ChartLink from "./chart";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { sendGet } from "../../api/axios";
import { linkApi } from "../../common/ngok";
import { getListQuanter } from "../../helpers/getListQuanter";

const SurveyLink = () => {
  const { t } = useTranslation();
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const citySelected = useSelector((state) => state.data.citySelected);
  const listQuanter = getListQuanter();
  const currentQuarter = useSelector((state) => state?.data?.currentQuarter);

  const [dataTableChart, setDatableChart] = useState(null);
  const [linkUrl, setLineUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDownload, setIsDownload] = useState("");

  const target_province_code = useMemo(() => {
    if (
      user?.is_superuser === "True" &&
      citySelected &&
      citySelected?.code !== -1
    ) {
      return citySelected?.code;
    }
    return user?.province_code;
  }, [user, citySelected]);

  const getDataDashboard = async (code) => {
    setIsLoading(true);
    try {
      const data = await sendGet(
        `dm/data/province/survey_progress?province_code=${code}`
      );
      if (data?.status === "successful") {
        setLineUrl(data?.survey_url);
        const dataClone = [...(data?.data[currentQuarter]?.data || [])];

        if (dataClone?.length > 0) {
          // Sort by total submissions (highest first)
          dataClone.sort(
            (a, b) =>
              (b.no_D1TT || 0) +
              (b.no_SM || 0) +
              (b.no_ST || 0) -
              ((a.no_D1TT || 0) + (a.no_SM || 0) + (a.no_ST || 0))
          );

          const chartData = [];
          chartData.push([
            "hospital_name",
            t("surveyLink.underMonth"),
            t("surveyLink.sectionMothers"),
            t("surveyLink.normalMother"),
            { role: "style" },
          ]);
          dataClone.forEach((element) => {
            chartData.push([
              element.hospital_name,
              element.no_D1TT || 0,
              element.no_SM || 0,
              element.no_ST || 0,
              "stroke-width: 4",
            ]);
          });
          setDatableChart(chartData);
        } else {
          setDatableChart([]);
        }
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setIsLoading(false);
    }
  };

  const indicesState = async (stat_label) => {
    setIsDownload(stat_label);
    const timeString = listQuanter[currentQuarter]?.split("/");
    let newcode = user?.province_code;

    if (
      user?.is_superuser === "True" &&
      citySelected &&
      citySelected?.code !== -1
    ) {
      newcode = citySelected?.code;
    }

    const response = await sendGet(
      `/dm/data/province/survey_progress/export?province_code=${newcode}&year=${timeString[1]}&quarter=${timeString[0][1]}&type=xlsx&data=${stat_label}`
    );
    if (response?.status === "successful") {
      window.open(`${linkApi}/${response?.data?.url}`);
    }
    setIsDownload("");
  };

  useEffect(() => {
    if (!target_province_code) return;
    getDataDashboard(target_province_code);
  }, [target_province_code, currentQuarter]);

  return (
    <SurveyLinkWrapper>
      {user?.is_superuser === "True" &&
        (Number(target_province_code) === 0 ||
          !Number(target_province_code)) && (
          <div style={{ color: "#888", fontSize: 16 }}>
            {t("surveyLink.letSelectCity")}
          </div>
        )}

      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        target_province_code &&
        Number(target_province_code) !== 0 && (
          <>
            <ToolbarRow>
              <LinkHeader>
                {dataTableChart?.length > 0 && (
                  <>
                    <Button
                      disabled={isDownload === "calls_stats"}
                      onClick={() => indicesState("calls_stats")}
                    >
                      {t("surveyLink.interviews")}
                    </Button>
                    <Button
                      disabled={isDownload === "indices_stats"}
                      onClick={() => indicesState("indices_stats")}
                    >
                      {t("surveyLink.summaryReport", {
                        name: citySelected?.name,
                      })}
                    </Button>
                  </>
                )}
                <Button onClick={() => window.open(linkUrl)}>
                  {t("surveyLink.link")}
                </Button>
              </LinkHeader>
            </ToolbarRow>

            <ContentArea>
              {dataTableChart?.length > 0 ? (
                <ChartContainer>
                  <ChartLink
                    dataTableChart={dataTableChart}
                    selected={citySelected}
                  />
                </ChartContainer>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    color: "#999",
                    marginTop: 60,
                    fontSize: 16,
                  }}
                >
                  {t("surveyLink.cityNotData")}
                </div>
              )}
            </ContentArea>
          </>
        )
      )}
    </SurveyLinkWrapper>
  );
};

export default SurveyLink;
